import BaseApi from './base'
import qs from 'qs'

class RecapComponents extends BaseApi {
  constructor () {
    super()
  }
  async getList (params) {
    return this.auth({
      url: '/recap_components',
      method: 'GET',
      params: { ...params },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false, encode: false })
      }
    })
  }
}

export default new RecapComponents()